import React, { useEffect, useState } from "react"
import Input from "reactstrap/lib/Input"

function DisciplineInput({ setDiscipline, initialValue }) {
	const [text, setText] = useState("")
	const [error, setError] = useState()

	useEffect(() => {
		if (initialValue) setText(initialValue)
	}, [])

	const onTimeChange = ({ target }) => {
		const formattedTime = target.value.replace(/\D/g, "")
		if (formattedTime.length < 5) {
			if (formattedTime.length > 2) {
				setText(formattedTime.substr(0, 2) + ":" + formattedTime.substr(2))
				setError()
			} else {
				setText(formattedTime)
			}
		}
		if (formattedTime.length === 4) {
			checkForErrors(
				formattedTime.substr(0, 2) + ":" + formattedTime.substr(2, 2)
			)
		}
	}

	const checkForErrors = (timeToCheck) => {
		if (!timeToCheck || timeToCheck.length === 0) {
			setError()
		} else if (timeToCheck.length !== 5) {
			setError("Vrijeme mora imati 4 broja. (npr. 00:00)")
		} else if (parseInt(timeToCheck.substr(3)) > 59) {
			setError("Sekunde nemogu bit iznad 59")
		}
	}

	return (
		<>
			<Input
				type="text"
				placeholder={"00:00"}
				value={text}
				onChange={onTimeChange}
				onBlur={() => {
					checkForErrors(text)
					setDiscipline(text)
				}}
				onFocus={() => setError()}
				invalid={!!error}
			/>
		</>
	)
}

export default DisciplineInput
